import axios from '../../../../api/axios';
import React,{useEffect,useState} from 'react';
import {useNavigate} from 'react-router-dom';
import { useAuth } from '../../../../ContextApp/AuthContext';
import { isEmpty } from '../../../../Utilities/Utils';
import { Link } from 'react-router-dom';
import {EyeFill,PencilFill,Trash3Fill} from "react-bootstrap-icons"
import Swal from 'sweetalert2';

function Deliberation(){
    const {user}=useAuth()
    const [sections,setSections]=useState([])
    const [affichage,setAffichage]=useState(true)
    const [section,setSection]=useState('')
    const [niveau,setNiveau]=useState('')
    const [deliberations,setDeliberations]=useState([])
    const navigate=useNavigate()
    const csrf=async () => {
        return await axios.get('/sanctum/csrf-cookie');
    };
    useEffect(()=>{
        handleSection()
        handleDeliberation()
    },[])
    const handleDeliberation=async()=>{
        await csrf()
        //{params:{idecole:user?.ecole?.id,annee_scolaire:user?.programme_scolaire?.annee_scolaire}}
        await axios.get('api/Deliberation',{params:{idecole:user?.ecole?.id,annee_scolaire:user?.programme_scolaire?.annee_scolaire}}).then((res)=>{
            setDeliberations(res?.data?.items)
        }).catch((err)=>{})
    }
    const handleSection=async()=>{
        await csrf()
            await axios.get(`api/sectionorg/${user?.ecole?.id}`).then((res)=>{
                setSections(res?.data?.items)
            }).catch((err)=>{

            })
    }
    const handleChangeSection=(e)=>{
       setSection(e.target.value)
       setNiveau('')
    }
    const changeAffichage=()=>{
        setAffichage(!affichage)
    }
    const getCritereLabel = (critere) => {
  switch (critere) {
    case "NombreReussite": return "Cours à réussir";
    case "NombreEchec": return "Cours à échouer";
    default: return "Aucun";
  }
};
    const DeleteDeliberation=async(iddelib)=>{
        await csrf()
            await axios.delete(`api/Deliberation/${iddelib}`).then((res)=>{
                                if(res.data.status===200){
                                    Swal.fire({
                                        title:'Message de confirmation',
                                        text:'Le critère de délibération a été supprimé avec succès',
                                        icon:'success'  
                                    })
                                }
                                handleDeliberation()
                            }).catch((err)=>{

                            })
    }
    
     const  AlertNotification=(iddeliberation)=>{
                    Swal.fire({
                        title:' Etes-vous sûr de vouloir supprimer ce critère de délibération ?',
                        text:'Ce critère va être supprimé',
                        icon:'warning',
                        showDenyButton:true,
                        showCancelButton:true,
                        confirmButtonText:'Confirmer',
                        denyButtonText:'Annuler'
                    }).then((resultat)=>{
                        if(resultat.isConfirmed){
                            DeleteDeliberation(iddeliberation)
                                }
                    })
                }

    return(
        <div className="container-fluid">
           <div className="row">
                <div className="col-12 justify-content-end">
                    <div className="col-4">
                        <button className="btn btn-primary d-md-none mt-2" onClick={changeAffichage} data-bs-toggle="collapse" data-bs-target="#parameters">
                            {
                                affichage ? "Afficher Filtres" : "Masquer Filtres"
                            }
                        </button>
                    </div>
                    
                </div>
           </div>
            
            <div className="card collapse py-4 mt-3 d-md-block" id="parameters">
                <div className="card-body ">
                    <div className="row ">
                        <div className="col-12 col-lg-4 mb-4 justify-content-between">
                            <h2 className="text-start">Gestion des délibérations</h2>
                        </div>
                        <div className="col-12 col-md-6 col-lg-3 mb-4">
                            <select className="form-select" id="section" name="section" onChange={(e)=>handleChangeSection(e)} value={section}>
                                <option value="" selected>Choix de la section</option>
                                {sections?.map((sect,index)=>(
                                    <option value={sect?.idsection} key={index}>{sect?.nom}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-12 col-md-6 col-lg-3 mb-4">
                            <select name="niveau" id="niveau" className="form-select" onChange={(e)=>setNiveau(e.target.value)} value={niveau}>
                                <option value="" selected>Choix du niveau</option>
                                {
                                     !isEmpty(section) && section==="1" ? (
                                        <>
                                            <option value="7">7ème année</option>
                                            <option value="8">8ème année</option>
                                            
                                        </>
                                    ):(
                                        <>
                                            <option value="1">1ère année</option>
                                            <option value="2">2ème année</option>
                                            <option value="3">3ème année</option>
                                            <option value="4">4ème année</option>
                                        </>
                                    )
                                }
                            </select>
                        </div>
                        <div className="col-6 col-lg-2">
                                <Link to="insertion" className="btn btn-primary btn-lg"> Ajout critère</Link>

                        </div>
                    </div>
                </div>
            </div>
            <div className="card mt-2">
                <div className="card-body py-4">
                    <table className="table table-striped table-hover table-bordered">
                        <thead>
                            <tr className="table-dark">
                                <th>#</th>
                                <th>Section</th>
                                <th>Niveau</th>
                                <th>Base critère</th>
                                <th>Pourcentage</th>
                                <th>Nombre des cours</th>
                                <th>Conduite</th>
                                <th>Décision</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                                { 
                                    deliberations?.map((delib,index)=>(
                                        <tr key={index}>
                                            <td>{index+1}</td>
                                            <td>{delib?.section?.nom}</td>
                                            <td>{delib?.niveau}</td>
                                            <td>{!isEmpty(delib?.base_critere) ? delib?.base_critere :"Aucune"}</td>
                                            <td>{delib?.testpourcentage+" "+delib?.pourcentage}%</td>
                                            <td>{!isEmpty(delib?.nombre_cours) && delib?.testnombrecour+" "+delib?.nombre_cours} {getCritereLabel(delib?.base_critere)}</td>
                                            <td>{!isEmpty(delib?.conduite) ? delib?.conduite : "Peu importe"}</td>
                                            <td>{delib?.decision}</td>
                                            <td className="text-start">
                                                                                <div className="d-flex justify-content-end gap-2">
                                                                                    
                                                
                                                                                    {/* Bouton Modifier */}
                                                                                    <button 
                                                                                        className="btn btn-sm btn-light text-primary border-0 shadow-sm action-btn" 
                                                                                        title="Modifier l'élève"
                                                                                        onClick={() => navigate(`${delib?.id}`)}
                                                                                    >
                                                                                        <PencilFill size={16} />
                                                                                    </button>
                                                
                                                                                    {/* Bouton Supprimer */}
                                                                                    <button 
                                                                                        className="btn btn-sm btn-light text-danger border-0 shadow-sm action-btn" 
                                                                                        title="Supprimer"
                                                                                        onClick={() => AlertNotification(delib?.id)}
                                                                                    >
                                                                                        <Trash3Fill size={16} />
                                                                                    </button>
                                                                                </div>
                                                                            
                                            </td>
                                        </tr>
                                    ))
                                }
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    )
}
export default Deliberation;